import { DropdownMenu } from '@octopus-do/octopus-storybook'
import type { AppState } from '@store/types'
import type React from 'react'
import { useSelector } from 'react-redux'

import { useArtboardMode } from '@/hooks'
import { Shortcut } from './components'

export const ProjectViewContent: React.FC = () => {
  const hideArrows = useSelector<AppState, boolean>(
    ({ canvas }) => canvas.arrow.hideArrows
  )

  const { simpleView: blocksHidden } = useArtboardMode()

  return (
    <>
      <DropdownMenu.Switch
        id="hide_blocks"
        on={blocksHidden}
        title="Hide blocks"
      />
      <DropdownMenu.Switch
        id="hide_arrows"
        on={hideArrows}
        title="Hide arrows"
      />
      <DropdownMenu.Divider />
      <DropdownMenu.Button id="150%" title="150%" />
      <DropdownMenu.Button id="100%" title="100%">
        <Shortcut type="100%" />
      </DropdownMenu.Button>
      <DropdownMenu.Button id="75%" title="75%" />
      <DropdownMenu.Button id="50%" title="50%" />
      <DropdownMenu.Button id="center" title="Zoom to center" />
      <DropdownMenu.Button id="fit" title="Zoom to fit">
        <Shortcut type="fit" />
      </DropdownMenu.Button>
    </>
  )
}
